import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "spinner__container fixed-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "spinner__text" }, "Loading...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_icon = _resolveComponent("logo-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade-delay",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_logo_icon, { class: "spinner" }),
        _hoisted_2
      ])
    ]),
    _: 1
  }))
}